module.exports = __webpack_public_path__ + "img/head.725a7000.png";